import { render } from "./SportsListView.vue?vue&type=template&id=51e36f9a&scoped=true"
import script from "./SportsListView.vue?vue&type=script&lang=js"
export * from "./SportsListView.vue?vue&type=script&lang=js"

import "./SportsListView.vue?vue&type=style&index=0&id=51e36f9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e36f9a"]])

export default __exports__